import store from 'store2'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ChatContext } from '~/service/chatConn'
import { post } from '~/utils/api'

export type VideoRoom = {
  active: boolean
  room: string
  pin: string
  agentToken: string
  agentId: string
}

type State = {
  videoRoom: VideoRoom
  clearRoom: () => void
  createRoom: () => void
  leaveRoom: () => void
}

export const VideoContext = React.createContext<State>({
  videoRoom: {} as VideoRoom,
  clearRoom: () => {},
  createRoom: () => {},
  leaveRoom: () => {},
})

type Props = {
  children: React.ReactNode
}

const VideoConn: React.FC<Props> = ({ children }) => {
  const active = store.get('videoActive')
  const room = store.get('videoRoom')
  const pin = store.get('videoPin')
  const agentToken = store.get('videoAgentToken')
  const agentId = store.get('videoAgentToken')

  const [videoRoom, setVideoRoom] = useState<VideoRoom>({
    active: active ? true : false,
    room: room ? room : '',
    pin: pin ? pin : '',
    agentToken: agentToken ? agentToken : '',
    agentId: agentId ? agentId : '',
  })

  const {
    sendMessage,
    setPause: setPauseChat,
    activeChat,
  } = useContext(ChatContext)

  const createRoom = async () => {
    const chatAccountId = activeChat?.chatAccountId.toString()
    const tag = activeChat?.id

    const res: any = await post('video/create', {
      chatAccountId,
      tag,
    })

    setVideoRoom({
      active: true,
      room: res.room,
      pin: res.pin,
      agentToken: res.agent_token,
      agentId: res.agent_opid,
    })

    const link =
      'https://' +
      process.env.AGENT_DOMAIN +
      `/api/janus/video?room=${res.room}&pin=${res.pin}&token=${res.client_token}&id=${res.client_opid}`

    sendMessage(link)
    setPauseChat(true)

    store.set('videoActive', '1')
    store.set('videoRoom', res.room)
    store.set('videoPin', res.pin)
    store.set('videoAgentToken', res.agent_token)
    store.set('videoAgentId', res.agent_opid)
  }

  const leaveRoom = () => {
    setVideoRoom({
      active: false,
      room: '',
      pin: '',
      agentToken: '',
      agentId: '',
    })

    setPauseChat(false)

    store.remove('videoActive')
    store.remove('videoRoom')
    store.remove('videoPin')
    store.remove('videoAgentToken')
    store.remove('videoAgentId')
  }

  const clearRoom = () => {
    setVideoRoom({
      active: false,
      room: '',
      pin: '',
      agentToken: '',
      agentId: '',
    })

    store.remove('videoActive')
    store.remove('videoRoom')
    store.remove('videoPin')
    store.remove('videoAgentToken')
    store.remove('videoAgentId')
  }

  return (
    <VideoContext.Provider
      value={{
        videoRoom: videoRoom,
        clearRoom: clearRoom,
        createRoom,
        leaveRoom,
      }}
    >
      {children}
    </VideoContext.Provider>
  )
}

export default VideoConn
